import React from 'react'
import PropTypes from 'prop-types'
import { FormattedMessage, injectIntl } from 'react-intl'
import Modal from '../Modal'
import Button from '../Button'
import Timer from '../Timer'


let SessionTimeoutModal = ({
    isOpen,
    onDismissAction,
    onReLoginAction
}) =>{
    return (
        <div className="SessionTimeoutModal__div">
            <Modal id="SessionTimeoutModal" open={isOpen} onDismiss={onDismissAction}><div className="modal-card SessionTimeoutModalCard">
                <header className="modal-card-head headingSection">
                    <div className="columns head headOuter"><div className="column"><div className="title has-text-left">
                        <FormattedMessage id="sessionTimeout.heading" defaultMessage="Session Timeout Alert"/>
                    </div></div></div>
                </header>
                <section className="modal-card-body main-body">
                    <div className="columns values description-text"><div className="column is-narrow has-text-weight-bold" style={{width: 'fit-content'}}>
                            <Timer initialMinute="2" label="Your session is about to timeout. Please act now or you will be automatically logged out in" callAction={onReLoginAction} timeOutLabel="Your session is about to timeout. Please act now or you will be automatically logged out."></Timer>
                    </div></div>
                </section>
                
                <footer className="modal-card-foot footerModal">
                    <div className="columns"><div className="column" style={{display: 'none'}}>
                        <Button className="is-primary is-fullwidth" onClick={onReLoginAction} >
                            <FormattedMessage id="sessionTimeout.reLogin" defaultMessage="Login"/>
                        </Button>
                    </div></div>
                </footer>
            </div></Modal>
        </div>
    )    
}


SessionTimeoutModal.propTypes = {
    isOpen: PropTypes.bool,
    onDismissAction: PropTypes.func,
    onReLoginAction: PropTypes.func,
  }

  SessionTimeoutModal.defaultProps = {
    isOpen: false,
    onDismissAction: () => {},
    onReLoginAction: () => {}
  }
export default injectIntl(SessionTimeoutModal)